export default "__VITE_PUBLIC_ASSET__20463847__"